// src/app/services/tracer.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TracerService {
  private clickHistory: string[] = [];

  // Permite que los componentes sepan si el tracer está activo
  public readonly isActive = environment.production ? false : true;

  // Renombrado a logAction para incluir inputs y clicks
  public logAction(info: string) {
    if (!this.isActive) return;

    const timestamp = new Date().toISOString();
    this.clickHistory.push(`[${timestamp}] ${info}`);

    if (this.clickHistory.length > 1000) { // Subimos a 1000 por si hay muchos inputs
      this.clickHistory.shift();
    }
  }

  public copiarLogAlPortapapeles() {
    if (this.clickHistory.length === 0) {
      alert('Aún no hay acciones registradas.');
      return;
    }
    const textoLog = this.clickHistory.join('\n');
    navigator.clipboard.writeText(textoLog).then(() => {
      alert('¡Historial copiado al portapapeles!');
    });
  }
}
